import { lazy } from 'react'
import { Projects } from 'pages/projects'
import { Payable } from './payable'
import Vendors from './vendor-manager/vendors'
import Reports from './reports'
import Clients from './clients'
import { Receivable } from './receivable'
import { VendorSkills } from 'pages/vendor-manager/vendor-skills'
import { Markets } from 'pages/vendor-manager/markets'
import Alerts from './alerts'
// import { ProjectCoordinatorDashboard } from 'pages/dashboard'

import { useUserRolesSelector } from 'utils/redux-common-selectors'

import { PerformanceTab } from 'features/performance/performance'
import { UserManagement } from './admin/user-management'
import { ProjectType } from './admin/project-type'
import { SupportTickets } from './admin/support-tickets'
import CypressReport from './cypress-report'
import Property from 'pages/property'
import TicketsPage from 'pages/tickets'
import TicketsEdit from './ticket-edit'
import ReportsDashboard from './reportsDashboard'

const VendorDashboard = lazy(() => import('pages/vendor/dashboard'))
const VendorTickets = lazy(() => import('pages/vendor/projects'))
const VendorProfilePage = lazy(() => import('pages/vendor/vendor-profile-v-portal'))
const VendorProjectDetails = lazy(() => import('pages/vendor/project-details'))

export default function useRoutesConfig() {
  const {
    isFPM,
    isProjectCoordinator,
    isVendor,
    isVendorManager,
    isDoc,
    isAdmin,
    isAccounting,
    isOperations,
    isClientManager,
    isConstructionOperations,
  } = useUserRolesSelector()
  switch (true) {
    case isFPM:
      return [
        { path: 'tickets', element: TicketsPage },
        { path: 'property', element: Property },
        { path: 'property-details/:projectId', element: TicketsEdit },
        { path: 'property-details/:projectId/ticket/:workOrderId', element: TicketsEdit },
        { path: 'property-details/:projectId/ticket/:ticketId/work-order/:workOrderId', element: TicketsEdit }
      ]
    case isProjectCoordinator:
      return [
        { path: 'tickets', element: TicketsPage },
        { path: 'property', element: Property },
        { path: 'receivable', element: Receivable },
        { path: 'vendors', element: Vendors },
        { path: 'clients', element: Clients },
        { path: 'property-details/:projectId', element: TicketsEdit },
        { path: 'property-details/:projectId/ticket/:workOrderId', element: TicketsEdit },
        { path: 'property-details/:projectId/ticket/:ticketId/work-order/:workOrderId', element: TicketsEdit },
        { path: 'payable', element: Payable },
        // { path: 'alerts', element: Alerts },
        // { path: 'pcDashboard', element: ProjectCoordinatorDashboard },
      ]
    case isVendorManager:
      return [
        { path: 'vendors', element: Vendors },
        { path: 'vendorSkills', element: VendorSkills },
        { path: 'markets', element: Markets },
      ]
    case isDoc:
      return [
        { path: 'property', element: Property },
        { path: 'vendors', element: Vendors },
        { path: 'reports', element: Reports },
        { path: 'reportsDashboard', element: ReportsDashboard },
        { path: 'performance', element: PerformanceTab },
        { path: 'clients', element: Clients },
      ]

    case isVendor:
      return [
        { path: 'vendorDashboard', element: VendorDashboard },
        { path: 'tickets', element: VendorTickets },
        { path: 'project-details/:projectId', element: VendorProjectDetails },
        { path: 'vendors', element: VendorProfilePage },
      ]
    case isAdmin:
      return [
        { path: 'tickets', element: TicketsPage },
        { path: 'property', element: Property },
        { path: 'userManager', element: UserManagement },
        { path: 'projectType', element: ProjectType },
        { path: 'property-details/:projectId', element: TicketsEdit },
        { path: 'property-details/:projectId/ticket/:workOrderId', element: TicketsEdit },
        { path: 'property-details/:projectId/ticket/:ticketId/work-order/:workOrderId', element: TicketsEdit },
        { path: 'projects', element: Projects },
        { path: 'payable', element: Payable },
        { path: 'support-tickets', element: SupportTickets },
        { path: 'receivable', element: Receivable },
        { path: 'vendors', element: Vendors },
        { path: 'clients', element: Clients },
        { path: 'reports', element: Reports },
        { path: 'reportsDashboard', element: ReportsDashboard },
        { path: 'markets', element: Markets },
        { path: 'performance', element: PerformanceTab },
        { path: 'vendorSkills', element: VendorSkills },
        { path: 'alerts', element: Alerts },
        { path: 'cypressReport', element: CypressReport },
      ]

    case isAccounting:
      return [
        { path: 'property-details/:projectId', element: TicketsEdit },
        { path: 'property-details/:projectId/ticket/:workOrderId', element: TicketsEdit },
        { path: 'property-details/:projectId/ticket/:ticketId/work-order/:workOrderId', element: TicketsEdit },
        { path: 'projects', element: Projects },
        { path: 'tickets', element: TicketsPage },
        { path: 'payable', element: Payable },
        { path: 'receivable', element: Receivable }
      ]
    case isOperations:
      return [
        { path: 'property', element: Property },
        { path: 'payable', element: Payable },
        { path: 'receivable', element: Receivable },
        { path: 'vendors', element: Vendors },
        { path: 'clients', element: Clients },
        { path: 'reports', element: Reports },
        { path: 'reportsDashboard', element: ReportsDashboard },
        { path: 'performance', element: PerformanceTab },
      ]
    case isClientManager:
      return [{ path: 'clients', element: Clients }]

    case isConstructionOperations:
      return [
        { path: 'property', element: Property },
        { path: 'vendors', element: Vendors },
      ]

    default:
      return []
  }
}
